import { useMutation, useQueryClient } from "@tanstack/react-query";
import { replaceReminderInListCaches } from "web_myplann/Api/Reminders/remindersCacheUtils";
import {
	patchRemindersIdV2,
	type UpdateReminderResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";
import type { ReminderFormModel } from "web_myplann/Reminders/Forms/reminderFormSchema";
import { mapReminderFormToUpdateRequest } from "web_myplann/Reminders/Mappers/mapReminderToRequest";

type UpdateReminderVariables = { id: string; model: ReminderFormModel };

export const useReminderUpdateMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<UpdateReminderResponseDTO, Error, UpdateReminderVariables>(
		{
			mutationFn: processResponse(({ id, model }: UpdateReminderVariables) =>
				patchRemindersIdV2(mapReminderFormToUpdateRequest(model), Number(id)),
			),
			onSuccess: (data) => {
				replaceReminderInListCaches(queryClient, data);
			},
		},
	);
};
